import React from "react";
import { Car, Calculator, ArrowRight } from "lucide-react";
import CTAHero from "./cta/CTAHero";
import ActionCard from "./cta/ActionCard";
import ContactCTA from "./cta/ContactCTA";
import BackgroundEffects from "./cta/BackgroundEffects";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const CallToActionSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.howItWorks?.callToActionSection || {};
  const sellCarData_i18n = sectionData.sellCar || {};
  const buyCarData_i18n = sectionData.buyCar || {};

  const handleSellCarClick = () => {
    window.location.href = "/salj-bilen";
  };

  const handleBuyCarClick = () => {
    window.location.href = "/kop-bil";
  };

  const sellCarData = {
    title: sellCarData_i18n.title || "Sälja Din Bil",
    description:
      sellCarData_i18n.description ||
      "Kostnadsfri värdering, professionell hantering och högsta möjliga pris.",
    features: sellCarData_i18n.features || [],
    buttonText: sellCarData_i18n.buttonText || "Starta Försäljning",
    buttonIcon: Calculator,
    secondaryIcon: ArrowRight,
    gradientFrom: "from-emerald-600",
    gradientTo: "to-cyan-600",
    featureColor: "bg-emerald-400",
    shadowColor: "shadow-emerald-500/25",
    animationDelay: 0,
    animationDirection: -1,
    iconRotation: 5,
    onButtonClick: handleSellCarClick,
  };

  const buyCarData = {
    title: buyCarData_i18n.title || "Köpa Din Bil",
    description:
      buyCarData_i18n.description ||
      "Tusentals kvalitetscertifierade bilar från hela Europa.",
    features: buyCarData_i18n.features || [],
    buttonText: buyCarData_i18n.buttonText || "Utforska Bilar",
    buttonIcon: Car,
    secondaryIcon: ArrowRight,
    gradientFrom: "from-blue-600",
    gradientTo: "to-purple-600",
    featureColor: "bg-blue-400",
    shadowColor: "shadow-blue-500/25",
    animationDelay: 0.2,
    animationDirection: 1,
    iconRotation: -5,
    onButtonClick: handleBuyCarClick,
  };

  return (
    <section className="py-12 md:py-12 bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 relative overflow-hidden">
      <BackgroundEffects />

      <div className="container mx-auto px-4 relative z-10">
        <CTAHero />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto mb-12 md:mb-16">
          <ActionCard {...sellCarData} />
          <ActionCard {...buyCarData} />
        </div>

        <ContactCTA />
      </div>
    </section>
  );
};

export default CallToActionSection;
